import { InfoOutlined } from "@mui/icons-material";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { AdmissionScheduleService } from "../../../services/AdmissionScheduleConfigService";
import { AdmissionConfigurationDTO } from "../../../types/AdmissionConfigurationDTO";
import { useAlert } from "../../contextProviders/AlertProvider";
import { useDialog } from "../../contextProviders/DialogContext";

const AdmissionScheduleConfigs: FC = () => {
	const [config, setConfig] = useState<AdmissionConfigurationDTO>({} as AdmissionConfigurationDTO);
	const { showAlert, showError } = useAlert();
	const { showDialog } = useDialog();

	const handleChange = (field: keyof AdmissionConfigurationDTO, value: number) => {
		setConfig(prev => ({
		...prev,
		[field]: value
		}));
	};

	useEffect(() => {
		const load = async () => {
			const response = await new AdmissionScheduleService().get();
			if (response?.data) {
				setConfig(response.data);
			} else {
				console.error('Erro ao buscar empresas que ignoram o 2240');
			}
		};
		load();
	}, []);

	return config.maximalDaysToSchedule
		? <Box sx={{width: '100%', padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2}}>
			<Typography variant="h6">
				As configurações abaixo são refletidas na lógica de agendamento de exames admissionais
			</Typography>
			<Box id="whatsapp-line">
				<Box sx={{display: 'flex', alignItems: "center"}}>
					<IconButton onClick={() => showDialog("Informações adicionais", "O valor definido neste campo indica quantos dias devem ser 'pulados' para o agendamento de exames.\nExemplo: se o valor configurado é 2, então serão pulados dois dias para a realização do agendamento. Neste caso, um agendamento feito na segunda-feira, só pode ser marcado para quarta-feira ou após")}>
						<InfoOutlined/>
					</IconButton>
					<Typography>Período mínimo para para agendamento de exames clínicos:</Typography>
				</Box>
				<TextField
					value={config?.minimalDaysToSchedule}
					onChange={(e) => handleChange('minimalDaysToSchedule', Number(e.target.value))}
					label="Dias"
					type="number"
					sx={{width: "90px"}}
				/>
			</Box>
			<Box id="whatsapp-line">
				<Box sx={{display: 'flex', alignItems: "center"}}>
					<IconButton onClick={() => showDialog("Informações adicionais", "O valor definido neste campo segue a mesma lógica do anterior, mas se aplica aos exames complementares")}>
						<InfoOutlined/>
					</IconButton>
					<Typography>Período mínimo para para agendamento de exames complementares:</Typography>
				</Box>
				<TextField
					value={config?.minimalDaysToScheduleComplementary}
					onChange={(e) => handleChange('minimalDaysToScheduleComplementary', Number(e.target.value))}
					label="Dias"
					type="number"
					sx={{width: "90px"}}
				/>
			</Box>
			<Box id="whatsapp-line">
				<Box sx={{display: 'flex', alignItems: "center"}}>
					<IconButton onClick={() => showDialog("Informações adicionais", "O valor definido neste campo indica quantos dias podem ser considerados para o agendamento de exames.\nExemplo: se o valor configurado é 5, então serão agendados exames somente para os próximos 5 dias. Datas posteriores não serão consideradas pela aplicação.")}>
						<InfoOutlined/>
					</IconButton>
					<Typography>Período máximo para para agendamento de exames:</Typography>
				</Box>
				<TextField
					value={config?.maximalDaysToSchedule}
					onChange={(e) => handleChange('maximalDaysToSchedule', Number(e.target.value))}
					label="Dias"
					type="number"
					sx={{width: "90px"}}
				/>
			</Box>
			<Button variant="contained" color="success" onClick={save}>Salvar</Button>
		</Box>
		: <></>;

	async function save() {
		const response = await new AdmissionScheduleService()
			.save(config);
		if (response?.status === 200) {
			showAlert('Configuração atualizada');
		} else {
			showError();
		}
	}
};

export default AdmissionScheduleConfigs;